import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

export const customerDOBDisabledDate = (current: dayjs.Dayjs) => {
  // Can only select dates older than 10 years
  return current && current >= dayjs().subtract(10, 'years');
};

export const disableAllDatesBeforeTomorrow = (current: dayjs.Dayjs) => {
  // Can not select days before tomorrow
  return current && current < dayjs().endOf('day');
};

export const disableAllDatesBeforeToday = (current: dayjs.Dayjs) => {
  // Can not select days before tomorrow
  return current && current < dayjs().subtract(1, 'day').endOf('day');
};

export const disableAllDatesAMonthAgo = (current: dayjs.Dayjs) => {
  // Can only select dates older than 10 years
  return current && current < dayjs().subtract(1, 'months');
};

export const disableAllDatesAWeekAgo = (current: dayjs.Dayjs) => {
  // Can only select dates older than 10 years
  return current && current < dayjs().subtract(7, 'days');
};

dayjs.extend(utc);
dayjs.extend(timezone);

const IST = 'Asia/Kolkata';

/**
 * The one operator date style, always India time: "Mon, 26 Oct, 16:20 IST", with the year only when it
 * is not the current year ("Tue, 5 Nov 2024, 09:05 IST"). A plain "YYYY-MM-DD" value is a calendar date,
 * not midnight, and prints without a clock. Java ZonedDateTime text ("…+05:30[Asia/Kolkata]") is accepted.
 * Delivery promises and requests use `formatDeliveryInstant` (DeliveryFollowUps/presentation), which
 * prints the same pattern and also knows when a stored 23:59:59 means "any time that day".
 */
export const formatToReadableDate = (
  uglyDate: dayjs.ConfigType,
  _tz?: string,
  now: dayjs.Dayjs = dayjs(),
) => {
  if (!uglyDate) {
    return '-';
  }
  const raw = typeof uglyDate === 'string' ? uglyDate.trim().replace(/\[[^\]]*\]$/, '') : uglyDate;
  const dateOnly = typeof raw === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(raw);
  const instant = dateOnly ? dayjs.tz(`${raw} 12:00`, IST) : dayjs(raw);
  if (!instant.isValid()) return '-';
  const parsed = dateOnly ? instant : instant.tz(IST);
  const day = parsed.format(
    parsed.year() === now.tz(IST).year() ? 'ddd, D MMM' : 'ddd, D MMM YYYY',
  );
  return dateOnly ? day : `${day}, ${parsed.format('HH:mm')} IST`;
};
